import en from './en-US'
import ru from './ru-Ru'

export default {
   ...en,
   ...ru
}